import { __rest } from "tslib";
import { Autocomplete as MuiAutocomplete, } from '@material-ui/lab';
import React from 'react';
import { IconButton, TextField } from '../..';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { CloseIcon, ChevronDownIcon } from '@getgo/chameleon-icons/react';
import { reactStyling, tokens } from '@getgo/chameleon-core';
const useStyles = makeStyles((theme) => {
    const { menuItem, menuItemHover, menuItemFocus, menuItemActive, textField, textFieldSmall, textFieldLarge, textFieldXlarge, textFieldDanger, textFieldSuccess, } = reactStyling(theme.tokens);
    return {
        option: Object.assign(Object.assign({}, menuItem), { padding: '0 1rem', '&:not(.Mui-disabled)': {
                '&:hover': Object.assign(Object.assign({}, menuItemHover), { backgroundColor: tokens.field04, color: tokens.text04 }),
                '&[data-focus="true"]&:not(:hover)': Object.assign({}, menuItemFocus),
                '&:active': Object.assign({}, menuItemActive),
            } }),
        paper: {
            overflow: 'visible',
        },
        listbox: {
            // prevent box shadow being cut
            margin: '0 -4px',
            padding: '0 4px',
        },
        endAdornment: {
            top: '50%',
            transform: 'translateY(-50%)',
        },
        popupIndicator: {
            '&:hover': {
                background: 'transparent',
            },
        },
        clearIndicator: {
            '&:hover': {
                background: 'transparent',
            },
        },
        inputRoot: (props) => {
            const stylingMap = {
                small: textFieldSmall,
                medium: textField,
                large: textFieldLarge,
                xlarge: textFieldXlarge,
            };
            return {
                '&[class*="MuiAutocomplete-inputRoot"]': Object.assign(Object.assign(Object.assign(Object.assign({}, (props.size ? stylingMap[props.size] : textField)), (props.success && textFieldSuccess)), (props.error && textFieldDanger)), { '&.Mui-disabled': {
                        color: tokens.text03,
                        borderColor: tokens.disabled04,
                        backgroundColor: tokens.disabled02,
                    } }),
            };
        },
        icon: {
            // let's win the CSS specificity war (in case of Success/Danger state of TextField)
            '&[class*="MuiButton-root"] svg': {
                color: tokens.icon04,
            },
        },
    };
});
export const Autocomplete = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const { size, TextFieldProps, autocompleteRef } = props, otherProps = __rest(props, ["size", "TextFieldProps", "autocompleteRef"]);
    const classes = useStyles({
        size: props.size,
        error: (_a = props === null || props === void 0 ? void 0 : props.TextFieldProps) === null || _a === void 0 ? void 0 : _a.error,
        success: (_b = props === null || props === void 0 ? void 0 : props.TextFieldProps) === null || _b === void 0 ? void 0 : _b.success,
    });
    const renderInput = (params) => {
        return React.createElement(TextField, Object.assign({}, params, TextFieldProps, { size: size, endAdornment: params.InputProps.endAdornment }));
    };
    return (React.createElement(MuiAutocomplete, Object.assign({ ref: autocompleteRef }, otherProps, { classes: Object.assign(Object.assign({}, otherProps.classes), { option: clsx(classes.option, (_c = otherProps === null || otherProps === void 0 ? void 0 : otherProps.classes) === null || _c === void 0 ? void 0 : _c.option), paper: clsx(classes.paper, (_d = otherProps === null || otherProps === void 0 ? void 0 : otherProps.classes) === null || _d === void 0 ? void 0 : _d.paper), listbox: clsx(classes.listbox, (_e = otherProps === null || otherProps === void 0 ? void 0 : otherProps.classes) === null || _e === void 0 ? void 0 : _e.listbox), endAdornment: clsx(classes.endAdornment, (_f = otherProps === null || otherProps === void 0 ? void 0 : otherProps.classes) === null || _f === void 0 ? void 0 : _f.endAdornment), popupIndicator: clsx(classes.popupIndicator, (_g = otherProps === null || otherProps === void 0 ? void 0 : otherProps.classes) === null || _g === void 0 ? void 0 : _g.popupIndicator), clearIndicator: clsx(classes.clearIndicator, (_h = otherProps === null || otherProps === void 0 ? void 0 : otherProps.classes) === null || _h === void 0 ? void 0 : _h.clearIndicator), inputRoot: clsx(classes.inputRoot) }), closeIcon: React.createElement(IconButton, { size: "xsmall", disabled: otherProps.disabled, className: classes.icon },
            React.createElement(CloseIcon, null)), popupIcon: React.createElement(IconButton, { size: "xsmall", disabled: otherProps.disabled, className: classes.icon },
            React.createElement(ChevronDownIcon, null)), renderInput: (_j = otherProps.renderInput) !== null && _j !== void 0 ? _j : renderInput })));
};
